import { useMemo } from 'react';

import { useUser } from '@/context/UserContext';
import { buildRequestContext, withRecordId as appendRecordId } from '@/services/requestContext';

export const useRequestContext = () => {
  const { getBusinessUnit, userData } = useUser();
  const source = getBusinessUnit();
  const userId = userData.userId;

  return useMemo(() => ({
    source,
    userId,
    createBaseRequestContext: () => buildRequestContext({ source, userId }),
    withRecordId: (recordId: string) => appendRecordId(buildRequestContext({ source, userId }), recordId),
  }), [source, userId]);
};
